/* FF Hero Click Tracking — fires GA4 select_promotion on hero image link clicks */
(function () {
  'use strict';
  var hero = document.querySelector('[id$="__media_grid_hero_2col"]');
  if (!hero) return;
  hero.querySelectorAll('a[href]').forEach(function (link) {
    link.addEventListener('click', function () {
      if (typeof gtag !== 'function') return;
      var href = this.getAttribute('href') || '';
      var label = (this.getAttribute('aria-label') || this.innerText || '').trim().replace(/\s+/g, ' ').substring(0, 60) || href;
      gtag('event', 'select_promotion', {
        creative_name: 'homepage_hero',
        creative_slot: '1',
        promotion_name: label,
        items: []
      });
    });
  });
})();